export const TABLE_MAX_WIDTH = '1810px'
export const TABLE_HEIGHT = 'calc(100vh - 230px)'
